/* eslint-disable @typescript-eslint/naming-convention, no-underscore-dangle, id-blacklist, id-match */

import { Injectable } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter, map, startWith } from 'rxjs/operators';
import { Breakpoint, initialDrawerState } from '../slide-drawer/slide-drawer.component';
import { RouterQuery } from '@datorama/akita-ng-router-store';

@Injectable({
  providedIn: 'root'
})
export class AppStateService {
  private _compactMenu = true;
  private _compactSidebar = true;
  private _compactTimeline = true;
  private _drawerState = new BehaviorSubject<Breakpoint>(initialDrawerState);
  private _sidebarOldestFirst = new BehaviorSubject<boolean>(false);

  drawerState: Observable<Breakpoint>;
  missionMode = false;
  missionModeObs: Observable<boolean>;
  sidebarRelativeDates = false;
  sidebarShowDates = false;
  missionId: string;

  user: any;

  constructor(private router: Router, private routerQuery: RouterQuery) {
    this.missionModeObs = this.router.events.pipe(
      filter(event => event instanceof NavigationStart || event instanceof NavigationEnd),
      map(() => this.missionId = this.routerQuery.getParams('id')),
      map(() => this.missionMode = this.router.url.includes('/mission/')),
      startWith(this.router.url.includes('/mission/'))
    );

    this.drawerState = this._drawerState.asObservable();
  }

  set compactMenu(value: boolean) {
    this._compactMenu = value;
    setTimeout(_ => dispatchEvent(new Event('resize')), 50);
  }

  get compactMenu() {
    return this._compactMenu;
  }

  set sidebarOldestFirst(value: boolean) {
    this._sidebarOldestFirst.next(value);
  }

  get sidebarOldestFirstObs() {
    return this._sidebarOldestFirst.asObservable();
  }

  set compactSidebar(value: boolean) {
    this._compactSidebar = value;
    setTimeout(_ => dispatchEvent(new Event('resize')), 50);
  }

  get compactSidebar() {
    return this._compactSidebar;
  }

  set compactTimeline(value: boolean) {
    this._compactTimeline = value;
    setTimeout(_ => dispatchEvent(new Event('resize')), 50);
  }

  get compactTimeline() {
    return this._compactTimeline;
  }

  setDrawerState(state: Breakpoint) {
    this._drawerState.next(state);
  }


}
